
import React, { Component } from 'react';
import { Container, Row, Col, Form, Button, Table } from "react-bootstrap";

import ErrorAlert from './ErrorAlert';
import 'antd/dist/antd.css';
import C from '../lib/Config';
import '../App.css';
import 'react-calendar/dist/Calendar.css';

export default class ConsentMale extends Component {
    constructor(props) {
        super(props)
        this.state = {
            patientName: '',
            gender: '',
            age: '',
            patientMobileNo: '',
            site: '',
            stage: '',
            intention: '',
            regimen: '',
            protocolName: '',
            protocolAdverseEvents: '',
            doctorName: '',
            qualification: '',
            specialty: '',
            institute: '',
            additionalCondition: '',
            checkbox1: false,
            checkbox2: false,
            checkbox3: false,
            checkbox4: false,
            checkbox5: false,
            checkbox6: false,
            checkbox7: false,
            checkbox8: false,
            checkbox9: false,
            checkbox10: false,
            checkbox11: false,
            checkbox12: false,
            checkbox13: false,
            checkbox14: false,
            checkbox15: false,
            errorAlertshow: false,
            errorAlertclose: false,
            patientConsentFormId: 0,
            planOfTreatment: '',
            cyclesPlaned: ''
        };
        this.toggleChangeCheckbox1 = this.toggleChangeCheckbox1.bind(this);
        this.toggleChangeCheckbox2 = this.toggleChangeCheckbox2.bind(this);
        this.toggleChangeCheckbox3 = this.toggleChangeCheckbox3.bind(this);
        this.toggleChangeCheckbox4 = this.toggleChangeCheckbox4.bind(this);
        this.toggleChangeCheckbox5 = this.toggleChangeCheckbox5.bind(this);
        this.toggleChangeCheckbox6 = this.toggleChangeCheckbox6.bind(this);
        this.toggleChangeCheckbox7 = this.toggleChangeCheckbox7.bind(this);
        this.toggleChangeCheckbox8 = this.toggleChangeCheckbox8.bind(this);
        this.toggleChangeCheckbox9 = this.toggleChangeCheckbox9.bind(this);
        this.toggleChangeCheckbox10 = this.toggleChangeCheckbox10.bind(this);
        this.toggleChangeCheckbox11 = this.toggleChangeCheckbox11.bind(this);
        this.toggleChangeCheckbox12 = this.toggleChangeCheckbox12.bind(this);
        this.toggleChangeCheckbox13 = this.toggleChangeCheckbox13.bind(this);
        this.toggleChangeCheckbox14 = this.toggleChangeCheckbox14.bind(this);
        this.toggleChangeCheckbox15 = this.toggleChangeCheckbox15.bind(this);
    }
    
    componentDidMount () {
        this.getConsentFormValue();
    }

    // Query params, not offsets: `search.slice(3)` only worked while `?p=<id>` was
    // the whole string, and silently returned "<id>&s=<id>" once a second param
    // was added.
    getQueryParams() {
        const search = (this.props.location && this.props.location.search) || '';
        const params = new URLSearchParams(search);
        return {
            treatmentPlanId: params.get('p') || 1,
            chemoScheduleId: params.get('s') || null,
        };
    }

    getConsentFormValue() {
        const { treatmentPlanId, chemoScheduleId } = this.getQueryParams();
        // Supplying the day returns that day's form, falling back to the legacy
        // plan-level form when the day has none yet — so a new day opens with the
        // previous answers rather than a blank sheet.
        const query = chemoScheduleId ? '?chemoScheduleId=' + chemoScheduleId : '';
        return fetch(C.getUrl() + '/userCase/getConsentFormValue/' + treatmentPlanId + query)
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            console.log(resObj);
            let tempData = resObj;
            
            this.setState({ patientName: tempData.patientName });
            this.setState({ gender: tempData.patientGender });
            this.setState({ age: tempData.patientAge });
            this.setState({ patientMobileNo: tempData.patientMobileNo });
            this.setState({ site: tempData.patientSite });
            this.setState({ stage: tempData.patientStage });
            this.setState({ intention: tempData.intention });
            this.setState({ regimen: tempData.regimen });
            this.setState({ protocolName: tempData.protocolName });
            this.setState({ protocolAdverseEvents: tempData.protocolAdverseEvents });
            this.setState({ doctorName: tempData.doctorName });
            this.setState({ qualification: tempData.qualification });
            this.setState({ specialty: tempData.speciality });
            this.setState({ institute: tempData.institute });
            this.setState({ additionalCondition: tempData.additionalCondition });
            this.setState({ patientConsentFormId: tempData.patientConsentFormId });
            this.setState({ checkbox1: tempData.checkbox1 });
            this.setState({ checkbox2: tempData.checkbox2 });
            this.setState({ checkbox3: tempData.checkbox3 });
            this.setState({ checkbox4: tempData.checkbox4 });
            this.setState({ checkbox5: tempData.checkbox5 });
            this.setState({ checkbox6: tempData.checkbox6 });
            this.setState({ checkbox7: tempData.checkbox7 });
            this.setState({ checkbox8: tempData.checkbox8 });
            this.setState({ checkbox9: tempData.checkbox9 });
            this.setState({ checkbox10: tempData.checkbox10 });
            this.setState({ checkbox11: tempData.checkbox11 });
            this.setState({ checkbox12: tempData.checkbox12 });
            this.setState({ checkbox13: tempData.checkbox13 });
            this.setState({ checkbox14: tempData.checkbox14 });
            this.setState({ checkbox15: tempData.checkbox15 });
            this.setState({ cyclesPlaned: tempData.cyclesPlaned });
            this.setState({ planOfTreatment: tempData.planOfTreatment });
        })
        .catch(err => {
            console.log("Error : " + err);
        });
    }

    formatDateMMDDYY(date) {
        if (date !== undefined && date !== "") {
            const d = new Date(date);
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        }
        return "";
    }

    printConsentForm(){
        window.print();
    }

    toggleChangeCheckbox1 = (event) => {
        this.setState({checkbox1: event.target.checked});
        if(this.state.checkbox2 == true && event.target.checked == true){
            this.setState({checkbox2: false});
        }
    }

    toggleChangeCheckbox2 = (event) => {
        this.setState({checkbox2: event.target.checked});
        if(this.state.checkbox1 == true && event.target.checked == true){
            this.setState({checkbox1: false});
        }
    }

    toggleChangeCheckbox3 = (event) => {
        this.setState({checkbox3: event.target.checked});
        if(this.state.checkbox4 == true && event.target.checked == true){
            this.setState({checkbox4: false});
        }
    }

    toggleChangeCheckbox4 = (event) => {
        this.setState({checkbox4: event.target.checked});
        if(this.state.checkbox3 == true && event.target.checked == true){
            this.setState({checkbox3: false});
        }
    }

    toggleChangeCheckbox5 = (event) => {this.setState({checkbox5: event.target.checked});}

    toggleChangeCheckbox6 = (event) => {this.setState({checkbox6: event.target.checked});}

    toggleChangeCheckbox7 = (event) => {this.setState({checkbox7: event.target.checked});}

    toggleChangeCheckbox8 = (event) => {this.setState({checkbox8: event.target.checked});}

    toggleChangeCheckbox9 = (event) => {this.setState({checkbox9: event.target.checked});}

    toggleChangeCheckbox10 = (event) => {this.setState({checkbox10: event.target.checked});}

    toggleChangeCheckbox11 = (event) => {this.setState({checkbox11: event.target.checked});}

    toggleChangeCheckbox12 = (event) => {this.setState({checkbox12: event.target.checked});}

    toggleChangeCheckbox13 = (event) => {this.setState({checkbox13: event.target.checked});}

    toggleChangeCheckbox14 = (event) => {this.setState({checkbox14: event.target.checked});}

    toggleChangeCheckbox15 = (event) => {this.setState({checkbox15: event.target.checked});}

    saveConsentForm(event){
        const { treatmentPlanId, chemoScheduleId } = this.getQueryParams();
        let data = {
            createdDt: new Date(),
            updatedDt: new Date(),
            patientTreatmentPlanId: treatmentPlanId,
            createdByIdUser: {
                userId: localStorage.getItem("userId")
            },
            updatedByIdUser: {
                userId: localStorage.getItem("userId")
            },
            checkbox1: this.state.checkbox1,
            checkbox2: this.state.checkbox2,
            checkbox3: this.state.checkbox3,
            checkbox4: this.state.checkbox4,
            checkbox5: this.state.checkbox5,
            checkbox6: this.state.checkbox6,
            checkbox7: this.state.checkbox7,
            checkbox8: this.state.checkbox8,
            checkbox9: this.state.checkbox9,
            checkbox10: this.state.checkbox10,
            checkbox11: this.state.checkbox11,
            checkbox12: this.state.checkbox12,
            checkbox13: this.state.checkbox13,
            checkbox14: this.state.checkbox14,
            checkbox15: this.state.checkbox15
        }
        // With a day supplied the save upserts on (planId, chemoScheduleId) and the
        // client-sent form id must be dropped — keeping it makes two treatment days
        // of one plan race for the same row, and whichever screen was opened last
        // overwrites the other day's answers.
        if (chemoScheduleId) {
            data.chemoScheduleId = chemoScheduleId;
        } else {
            data.patientConsentFormId = this.state.patientConsentFormId;
        }
        return fetch(C.getUrl() + '/userCase/saveConsentForm', {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(res => {
            let obj = res;
            if (obj.message !== null && obj.message == "SUCCESS") {
                alert("Record updated successfully.");
            } else {
                let objmsg = JSON.parse(obj.message);
                if(objmsg!=null && objmsg.patientConsentFormId != 0){
                    this.setState({ patientConsentFormId: objmsg.patientConsentFormId })
                }
                alert("Record save successfully.");
            }
        })
        .catch(err => {
            console.log("Error : " + err);
            this.setState({ errorAlertshow: true });
            setTimeout(() => {
                this.setState({ errorAlertshow: false })
            }, 3000)
        });
    }
    
    render() {
        return (
            <div className="d-flex" id="wrapper">
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Container fluid>
                            <div className="app-content">
                                <section className="section" id="accordion">
                                    <div className="form formBackground">
                                        <div className="lightSeperator">
                                            <legend >PATIENT CONSENT FORM (PART A)</legend>
                                            <Row>
                                                <Col lg='12'>
                                                    <Table responsive="lg" striped bordered>
                                                        <tbody>
                                                            <tr role="row" className="odd">
                                                                <td><b>Name</b></td>
                                                                <td>{this.state.patientName}</td>
                                                                <td><b>Gender</b></td>
                                                                <td>{this.state.gender}</td>
                                                            </tr>
                                                            <tr role="row" className="odd">
                                                                <td><b>Age</b></td>
                                                                <td>{this.state.age}</td>
                                                                <td><b>Contact Number</b></td>
                                                                <td>{this.state.patientMobileNo}</td>
                                                            </tr>
                                                            <tr role="row" className="odd">
                                                                <td><b>Site</b></td>
                                                                <td>{this.state.site}</td>
                                                                <td><b>Stage</b></td>
                                                                <td>{this.state.stage}</td>
                                                            </tr>
                                                            <tr role="row" className="odd">
                                                                <td><b>Intention</b></td>
                                                                <td>{this.state.intention}</td>
                                                                <td><b>Regimen</b></td>
                                                                <td>{this.state.protocolName}</td>
                                                            </tr>
                                                            <tr role="row" className="odd">
                                                                <td><b>Cycles Planned</b></td>
                                                                <td>{this.state.cyclesPlaned}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table >
                                                </Col>
                                            </Row>
                                            <Row>
                                                <p className="infoText"><b>Plan of Treatment: </b><br></br></p>
                                                <p className="infoText">{this.state.planOfTreatment}</p>
                                            </Row>
						                    <br></br>
						                    <Row>
                                                <p className="infoText">Statement by the treating doctors team<br></br>I have been explained in the language that <b>{this.state.patientName}</b> understand. The nature, stage, treatment options and likely outcomes of the systemic treatment involved. Regarding the systemic therapy I have been explained in details about the drugs involved in the treatment, its mode of administration, its benefit and risks together with those of available alternative treatments including the option of no treatment. I have explained the goals of treatment as <b>{this.state.protocolName}</b>.<br></br>
                                                </p>
                                                <p className="infoText">The following serious or frequently occurring adverse events (including the risk of hospitalization and mortality) have been explained by me. I have provided the links to online resource (patient information leaflet) which can be used as additional source of information.<br></br>
                                                </p>
                                                <p className="infoText mb-2">The adverse events explained are listed below…...<br></br><p className="mt-3 mb-0"><b>{this.state.protocolAdverseEvents}</b></p>
                                                </p>
                                            </Row>
                                            <br></br>
                                            <Row>
                                                <p className="infoText">
                                                    I have explained in detailed regarding the need for contraception and avoidance of pregnancy during this treatment. <br></br>
                                                </p>
                                                <p className="infoText">
                                                    <div className="form-group infoText" ><input type="checkbox" checked={this.state.checkbox1} onChange={this.toggleChangeCheckbox1} className="mr-2" /> I have confirmed that patient has understood the language. As the patient can understand the language that I speak </div>
                                                    <p className="infoText">OR</p>
                                                    <div className="form-group infoText" ><input type="checkbox" checked={this.state.checkbox2} onChange={this.toggleChangeCheckbox2} className="mr-2" /> I have confirmed that patient did not understand the language that I speak.  Hence, I have used an interpreter.</div>
                                                    <p className="infoText">Statement of interpreter</p>
                                                    <p className="infoText">I have interpreted the information provided by the treating doctor to best of my ability and have explained in the language that patient understands.</p>
                                                </p>
                                            </Row>
                                            <Row>
                                                <Col lg='12'>
                                                    <Table responsive="lg" striped bordered>
                                                        <tbody>
                                                            <tr role="row" className="odd">
                                                                <td><b>Doctor's Name</b></td>
                                                                <td>{this.state.doctorName}</td>
                                                                <td><b>Qualification</b></td>
                                                                <td>{this.state.qualification}</td>
                                                            </tr>
                                                            <tr role="row" className="odd">
                                                                <td><b>Specialty</b></td>
                                                                <td>{this.state.specialty}</td>
                                                                <td><b>Institute</b></td>
                                                                <td>{this.state.institute}</td>
                                                            </tr>
                                                            <tr role="row" className="odd">
                                                                <td><b>Doctor's Signature</b></td>
                                                                <td></td>
                                                                <td><b>Today's Date</b></td>
                                                                <td>{this.formatDateMMDDYY(new Date())}</td>
                                                            </tr>
                                                            <tr role="row" className="odd">
                                                                <td><b>Interpreters Signature</b></td>
                                                                <td></td>
                                                                <td><b>Today's Date</b></td>
                                                                <td>{this.formatDateMMDDYY(new Date())}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="lightSeperator">
                                            <legend className="pb-4" >Consent - Part B</legend>
                                            <p className="infoText">Statement of interpreter</p><br></br>
                                            <p className="infoText">
                                                I have explained in detailed regarding the need for contraception and avoidance of pregnancy during this treatment.<br></br>
                                            </p>
                                            <p className="infoText">
                                                <div className="form-group infoText" ><input type="checkbox" checked={this.state.checkbox3} onChange={this.toggleChangeCheckbox3} className="mr-2" /> I understand the benefits of treatment if it is successful. But I am also aware that my treating physician cannot be sure that treatment will benefit me</div>
                                                <p className="infoText">OR</p>
                                                <div className="form-group infoText" ><input type="checkbox" checked={this.state.checkbox4} onChange={this.toggleChangeCheckbox4} className="mr-2" /> I understand that my treatment can have led to side effects both immediate or delayed. The common and potentially harmful adverse effects have informed to me.</div>
                                                <div className="form-group infoText"><input type="checkbox" checked={this.state.checkbox5} onChange={this.toggleChangeCheckbox5} className="mr-2" /> I understand that the treatment can cause side effects besides those listed above. Response to treatment can differ among patients and I could have others side effects that may be rare or not reported by others</div>
                                                <div className="form-group infoText" ><input type="checkbox" checked={this.state.checkbox6} onChange={this.toggleChangeCheckbox6} className="mr-2" /> I have understood the information provided. I was given enough time to understand and ask any queries. My queries if any have been answered satisfactorily.</div>
                                                <div className="form-group infoText"><input type="checkbox" checked={this.state.checkbox7} onChange={this.toggleChangeCheckbox7} className="mr-2" /> I am aware that I have the right to refuse or stop my treatment at any time. Consequences of doing so have also explained to me in detail.</div>
                                                <div className="form-group infoText" ><input type="checkbox" checked={this.state.checkbox8} onChange={this.toggleChangeCheckbox8} className="mr-2" /> I am aware about the mode of administration, schedule and precautions to be taken during and after my treatment.</div>
                                                <div className="form-group infoText"><input type="checkbox" checked={this.state.checkbox9} onChange={this.toggleChangeCheckbox9} className="mr-2" /> I am aware that in case of development of any serious or intolerable adverse events. I need to visit the emergency department or my treating physician.</div>
                                                <div className="form-group infoText"><input type="checkbox" checked={this.state.checkbox10} onChange={this.toggleChangeCheckbox10} className="mr-2" /> I understand that I may require blood product transfusion, antibiotics or other supportive measures as per clinical situation which may not be listed on this form.</div>
                                                <div className="form-group infoText"><input type="checkbox" checked={this.state.checkbox11} onChange={this.toggleChangeCheckbox11} className="mr-2" /> I consenting to the above mentioned treatment recommendation by signing this document voluntarily.</div>
                                                <div className="form-group infoText"><input type="checkbox" checked={this.state.checkbox12} onChange={this.toggleChangeCheckbox12} className="mr-2" /> I consent for utilization of my treatment records for research purposes. Any such research will be approved according to the relevant institutional ethical practices. My identity will not be revealed during utilization of the data.</div>
                                                <div className="form-group infoText"><input type="checkbox" checked={this.state.checkbox13} onChange={this.toggleChangeCheckbox13} className="mr-2" /> For Males: I have been informed about the impact of this treatment on my fertility. I have been given the options of fertility preservation.</div>
                                                <div className="form-group infoText"><input type="checkbox" checked={this.state.checkbox14} onChange={this.toggleChangeCheckbox14} className="mr-2" /> For Males: I have refused/requested options of fertility preservation.</div>
                                                <div className="form-group infoText"><input type="checkbox" checked={this.state.checkbox15} onChange={this.toggleChangeCheckbox15} className="mr-2" /> For Males: I am aware that the said treatment can unknown effect my sperms and hence I should not father children during course of my treatment.</div>
                                                <div className="form-group infoText"><input type="checkbox" className="mr-2" />I have read and understood the product monograph of the recommended chemotherapy and I agree to follow the advice provided on monograph.</div>
                                            </p>
                                            <Row>
                                                <Col lg='12'>
                                                    <Form.Group className='input-group mb-6'>
                                                        <Form.Control as="textarea" placeholder='' disabled value={this.state.additionalCondition} name='Additional Conditions / Risks' rows={2}  />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg='12'>
                                                    <Table responsive="lg" striped bordered>
                                                        <tbody>
                                                            <tr role="row" className="odd">
                                                                <td style={{ width: "300px" }}><b>Patient Name</b></td>
                                                                <td style={{ width: "300px" }}>{this.state.patientName}</td>
                                                                <td style={{ width: "300px" }}><b>Signature with Date</b></td>
                                                                <td style={{ width: "300px" }}></td>
                                                            </tr>
                                                            <tr role="row" className="odd">
                                                                <td><b>Name of Legal guardian</b></td>
                                                                <td></td>
                                                                <td><b>Signature with Date</b></td>
                                                                <td></td>
                                                            </tr>
                                                            <tr role="row" className="odd">
                                                                <td><b>Name of the witness</b></td>
                                                                <td></td>
                                                                <td><b>Signature with Date</b></td>
                                                                <td></td>
                                                            </tr>
                                                            <tr role="row" className="odd">
                                                                <td><b>Name of interpreter</b></td>
                                                                <td></td>
                                                                <td><b>Signature with Date</b></td>
                                                                <td></td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            <Row className="submit">
                                                <Col lg='12' className="text-center">
                                                    <Button variant="secondary" className="btn-primary mr-2" onClick = {() => this.printConsentForm()}> Print</Button>
                                                    <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveConsentForm.bind(this)}> Save</Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </Container>
                        <ErrorAlert show={this.state.errorAlertshow} alertBody={'Something went wrong. Please try again'}/>
                    </div>
                </div>
            </div>
        )
    }
}